
import { lazy } from "react";
import AddLocationIcon from "@mui/icons-material/AddLocation";

import LocationOnIcon from "@mui/icons-material/LocationOn";
import { Navigate } from "react-router-dom";

const LocationCreate = lazy(() => import("../components/locationCreate"));
const LocationList = lazy(() => import("../components/locationList"));

const locationRoute = {
  icon: LocationOnIcon,
  name: "Location Management",
  link: "/location-management",
  path: "location-management",
  index: 15,
  element: "",
  superAdminView: false,
  permission: "Zone-Read",
  children: [
    {
      path: "zone",
      element: <LocationList />,
      permission: "Zone-Read",
      name: "Zone",
      index: 1,
      link: "location-management/zone",
      icon: AddLocationIcon,
    },
    {
      path: "zone/create",
      element: <LocationCreate />,
    },
    {
      path: "zone/:id",
      element: <LocationCreate />,
    },
    {
      path: "",
      element: <Navigate to="zone" replace />,
    },
  ],
};
export default locationRoute;
